<div class="info-row">
	<div class="logo-cell cell">
		<img src="assets/images/footer/logo.png" [alt]="'FOOTER.LOGOALT' | translate">
	</div>
	<div class="links-cell cell">
		<p>{{ 'FOOTER.LINKS.TITLE' | translate }}</p>
		<ul>
			<li><a routerLink="/formations">{{ 'FOOTER.LINKS.CATALOG' | translate }}</a></li>
			<li><a routerLink="/slides/who-we-are">{{ 'FOOTER.LINKS.WHOWEARE' | translate }}</a></li>
			<li><a routerLink="/slides/who-we-are" [queryParams]="{ accessibility: 'true' }">{{ 'CATALOG.DETAIL.BODY.ACCESSIBILITY.TITLE' | translate }}</a></li>
			<li>
				<a href="https://www.youtube.com/channel/UC4va3GZE--0Wz6VRDr2xjqg"
					 target="_blank">
					{{ 'FOOTER.LINKS.YOUTUBE' | translate }}
				</a>
				<def-sprites class="sprite-center" sprite="social-youtube" width="24px" height="24px" color="white">
				</def-sprites>
			</li>
		</ul>
	</div>
	<div class="info-cell cell">
		<p>{{ 'FOOTER.INFO.TITLE' | translate }}</p>
		<ul>
			<li>{{ 'FOOTER.INFO.PHONE.LABEL' | translate }}
				<a [href]="'tel:' + ('FOOTER.INFO.PHONE.VALUE' | translate)">{{ 'FOOTER.INFO.PHONE.VALUE' | translate }}</a>
			</li>
			<li>{{ 'FOOTER.INFO.MAIL.LABEL' | translate }}
				<a [href]="'mailTo:' + ('FOOTER.INFO.MAIL.VALUE' | translate)">{{ 'FOOTER.INFO.MAIL.VALUE' | translate }}</a>
			</li>
			<li>
				<a href="/slides/faq">{{ 'FOOTER.INFO.FAQ.VALUE' | translate }}</a>
			</li>
		</ul>
	</div>
	<div class="map-cell cell">
		<a href="https://www.google.com/maps/place/Decathlon+Exchange/@50.6416968,3.1379569,15z/data=!4m2!3m1!1s0x0:0x10c6a3d7d401bdf2?sa=X&ved=2ahUKEwik5KXh3rzvAhUPExoKHVGFC7QQ_BIwFHoECBwQBQ"
			 target="_blank">
			<img src="assets/images/footer/map.png" [alt]="'FOOTER.MAPALT' | translate">
		</a>
	</div>
</div>
<div class="legal-row">
	<div class="cell">
		<div>
			<a href="https://docs.google.com/presentation/d/1hxPJScD4Je1CTJrysdh9JYyAN6QYd3vld95fJESJf-4/edit?usp=sharing">
				{{ 'FOOTER.LEGAL.LEGALNOTICES' | translate }}
			</a> |
			<a href="https://docs.google.com/presentation/d/1QPelW8ZSrKzPJE5GK6AWjVHTxgWKjFwfohwAsee4Imo/edit?usp=sharing">
				{{ 'FOOTER.LEGAL.SALESCONDITIONS' | translate }}
			</a>
		</div>
	</div>
</div>
<div class="copyright-row">
	<p>{{ 'FOOTER.LATESTUPDATE' | translate:{date: date} }}</p>
	<p>{{ 'FOOTER.COPYRIGHT' | translate:{year: year} }}</p>
</div>
